import { FouSelectObject } from 'src/utils/objects/fou-select'
import { DraggableObject } from 'src/utils/objects/draggable'
import Methods from 'src/pages/submissions/components/graphics/script/methods/'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container/'
import FouPicture from 'components/tools/fou-picture/'
import FouSelect from 'components/form/fou-select/'
import FouSelectTags from 'components/form/fou-select-tags/'
import FouExpand from 'components/tools/fou-expand/'
import GraphicItem from 'src/pages/submissions/components/graphics/item'
import GraphicUploader from 'src/pages/submissions/components/graphics/uploader'
import Draggable from 'vuedraggable'
import { SubmissionObject, errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import { mapGetters } from 'vuex'
import { TimeoutUtil } from 'src/utils/helper/timer'
import VSelect from 'src/components/form/v-select/index.vue'
import TextField from 'src/components/form/text-field/index.vue'
import DOMPurify from 'dompurify'
import { useForm } from 'vee-validate'
import { isEmpty } from 'lodash'

export default {
  name: 'graphics',

  components: {
    MyfontsShortCircleIcon,
    ...FouGrid,
    FouGroup,
    FouModal,
    FouContainer,
    FouPicture,
    FouSelect,
    FouSelectTags,
    FouExpand,
    GraphicItem,
    GraphicUploader,
    Draggable,
    VSelect,
    TextField
  },

  data() {
    return {
      sortOrders: [],
      countries: FouSelectObject(),
      countriesFeature: false,
      fouDraggable: DraggableObject(this),
      item: SubmissionObject.getStep('graphics'),
      unsubscribe: null,
      minSlides: 5,
      graphicsTimer: TimeoutUtil(),
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      displayStyle: 'display: block',
      minImageWidth: process.env.MIN_IMAGE_WIDTH,
      minImageHeight: process.env.MIN_IMAGE_HEIGHT
    }
  },

  setup() {
    const { errors: formError, validate } = useForm()
    return {
      formError,
      validate
    }
  },

  watch: {
    formError: {
      handler(newVal) {
        this.handleSubmissionErrors(newVal)
      },
      immediate: true
    },
    sortOrders: {
      handler(newVal) {
        this.validateAVCheckStatus();
      },
      deep: true
    }
  },

  created() {
    this.addReadyState()
    this.item.set({
      context: this
    })
    this.setSubscriptions()
    this.getAll({
      submissionId: this.submission.id
    })
      .then(() => {
        return this.setCountries()
      })
      .then(() => {
        return this.setSortOrders()
      })
      .then(() => {
        return this.syncGraphics()
      })
      .then(() => {
        this.ready.state = 'set'
        this.$events.$emit('on_load_validate_sections', 'graphics')
      })
      .then(() => {
        this.setSubmissionBuild({
          before: this.buildSubmission
        });
      });
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },

  beforeUnmount() {
    this.unsubscribe()
    this.$events?.$off('trigger:validate')
    this.$store.commit('graphics/setScanStatus', null);
    this.$store.commit('graphics/setErrorShown', false);
  },

  methods: {
    ...Methods,
    ...SubmissionMethods,
    draggableStart() {
      this.fouDraggable.start()
    },
    draggableEnd() {
      this.fouDraggable.end()
    },
    handleSubmissionErrors(errors) {
      for (const key in errors) {
        submissionErrors.value.push({ [key]: errors[key] })
      }
      if (!Object.hasOwn(errors, `posters_${this.defaultSortOrder?.iso} graphics`)) {
        submissionErrors.value = submissionErrors.value.filter(
          error => !Object.keys(error).includes('posters_US graphics')
        )
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
    },
    validateAVCheckStatus() {
      if (!this.defaultSortOrder || !this.defaultSortOrder.graphics) {
        return '';
      }
    }
  },

  computed: {
    ...SubmissionComputed,
    defaultSortOrder() {
      const dflt = this.sortOrders.filter(o => o.iso === this.$store.getters['settings/iso'])[0]
      if (!isEmpty(dflt)) {
        return dflt || { graphics: [] }
      }
    },
    graphicsDescription() {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.graphics.description'), {
        ADD_ATTR: ['target'],
      })
    },
    imagesWithPlaceHolder() {
      const emptyArray = Array.from({ length: 5 }).fill({})
      if (this.defaultSortOrder.graphics.length >= 5) {
        return this.defaultSortOrder.graphics
      } else {
        return [...this.defaultSortOrder.graphics, ...emptyArray].slice(0, 5)
      }
    },
    countrySortOrders() {
      return this.sortOrders.filter(o => o.iso !== this.$store.getters['settings/iso'])
    },
    ...mapGetters('graphics', {
      graphicsList: ['list'],
      graphicsStates: ['states'],
      graphicsFindByGraphicId: ['findByGraphicId'],
      graphicsFindByImageId: ['findByImageId'],
      scanStatus: ['scanStatus']
    })
  }
}
